const footerBn = {
	company: 'গ্রামীণ বাজার',
	description: 'বাংলাদেশের সবচেয়ে বড় অনলাইন মার্কেটপ্লেস। আপনার দৈনন্দিন প্রয়োজনীয় সবকিছু এখানে পাবেন।',
	links: {
		company: 'কোম্পানি',
		business: 'ব্যবসা',
		support: 'সহায়তা',
		about: 'আমাদের সম্পর্কে',
		career: 'ক্যারিয়ার',
		contact: 'যোগাযোগ',
		help: 'সাহায্য',
		becomeSeller: 'বিক্রেতা হিসেবে যোগ দিন',
		businessAccount: 'বিজনেস অ্যাকাউন্ট',
		marketplacePolicy: 'মার্কেটপ্লেস নীতিমালা',
		deliveryPolicy: 'ডেলিভারি নীতিমালা',
		returnPolicy: 'রিটার্ন পলিসি',
		privacyPolicy: 'প্রাইভেসি পলিসি',
	},
	contact: {
		heading: 'যোগাযোগ',
		address: 'বাড়ি #১২৩, রোড #৪৫, বনানী, ঢাকা-১২১৩',
	},
	copyright: (year) => `© ${year} গ্রামীণ বাজার। সর্বস্বত্ব সংরক্ষিত।`,
};

export default footerBn;


